import Loader from "react-loader-spinner";
import './ProgressPanel.css';

export function ProgressPanel(props) {

    return <div id={props.id}>
                <div className="progress-panel">
                    <Loader color="black" type="Watch" />
                    {props.lang === "hu" && <div>Adatok letöltése: {props.progress}%</div>}
                    {props.lang === "en" && <div>Fetching data: {props.progress}%</div>}
                </div>
            </div>;
}
